module.exports = __webpack_public_path__ + "static/media/chevron-left.dac54f02.svg";